(function () {
  var YT_ORIGIN = 'https://www.youtube.com';
  var STATE_PLAYING = 1;
  var STATE_PAUSED = 2;
  var STATE_ENDED = 0;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getVideos(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-featured-player-video]'));
  }

  function getSlides(stage) {
    return Array.prototype.slice.call(stage.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
  }

  function hardenIframe(iframe) {
    if (!iframe) return;
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
  }

  function command(iframe, func, args) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: args || [] }),
      '*'
    );
  }

  function embedSrc(videoId, muted) {
    return (
      YT_ORIGIN +
      '/embed/' +
      videoId +
      '?enablejsapi=1&autoplay=1&mute=' +
      (muted ? '1' : '0') +
      '&controls=0&rel=0&modestbranding=1&playsinline=1&loop=1&playlist=' +
      videoId +
      '&fs=0&disablekb=1&iv_load_policy=3&cc_load_policy=0&origin=' +
      encodeURIComponent(window.location.origin)
    );
  }

  function syncVideoUi(video, playing, muted) {
    if (!video) return;
    video.classList.toggle('is-playing', playing);
    video.classList.toggle('is-paused', !playing);
    video.classList.toggle('is-muted', muted);

    var clip = video.querySelector('.product-featured-player__player-clip');
    if (clip) clip.setAttribute('aria-hidden', 'true');

    var playback = video.querySelector('[data-featured-player-playback]');
    if (playback) {
      var playLabel = playback.getAttribute('data-play-label') || '';
      var pauseLabel = playback.getAttribute('data-pause-label') || '';
      playback.setAttribute('aria-label', playing ? pauseLabel : playLabel);
      playback.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }

    var sound = video.querySelector('[data-featured-player-sound]');
    if (sound) {
      var muteLabel = sound.getAttribute('data-mute-label') || '';
      var unmuteLabel = sound.getAttribute('data-unmute-label') || '';
      sound.setAttribute('aria-label', muted ? unmuteLabel : muteLabel);
      sound.setAttribute('aria-pressed', muted ? 'true' : 'false');
    }
  }

  function parseYtMessage(data) {
    if (!data) return null;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    if (typeof data !== 'object') return null;
    return data;
  }

  function createSlot(host, controller) {
    var clip = host.querySelector('.product-featured-player__player-clip');
    var videoId = host.getAttribute('data-youtube-id') || '';
    var iframe = null;

    function applyMute() {
      command(iframe, controller.muted ? 'mute' : 'unMute');
    }

    function play() {
      applyMute();
      command(iframe, 'playVideo');
    }

    function pause() {
      command(iframe, 'pauseVideo');
    }

    function bindIframe(nextIframe) {
      iframe = nextIframe;
      host.featuredIframe = iframe;
      hardenIframe(iframe);
      iframe.addEventListener('load', function () {
        iframe.contentWindow.postMessage('{"event":"listening","id":"featured-player"}', '*');
        command(iframe, 'addEventListener', ['onStateChange']);
        if (controller.shouldPlay(host)) {
          applyMute();
          command(iframe, 'playVideo');
          syncVideoUi(host, true, controller.muted);
        }
      });
    }

    function createAndPlay() {
      if (!videoId || !clip) return;
      if (iframe) {
        play();
        syncVideoUi(host, true, controller.muted);
        return;
      }

      var next = document.createElement('iframe');
      next.className = 'product-featured-player__iframe js-youtube';
      next.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      next.setAttribute('allowfullscreen', '');
      next.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      next.title = '';
      next.setAttribute('aria-hidden', 'true');
      clip.appendChild(next);
      bindIframe(next);
      next.src = embedSrc(videoId, controller.muted);
      syncVideoUi(host, true, controller.muted);
    }

    return {
      host: host,
      createAndPlay: createAndPlay,
      play: play,
      pause: pause,
      applyMute: applyMute,
      hasPlayed: false,
      getIframe: function () {
        return iframe;
      },
    };
  }

  function createController(root) {
    var controller = {
      root: root,
      stage: root.querySelector('.product-featured-player__stage'),
      activeIndex: 0,
      inView: false,
      userPaused: false,
      muted: true,
      slots: [],
      getActiveHost: function () {
        if (!this.stage) return getVideos(root)[0] || null;
        var slides = getSlides(this.stage);
        var slide = slides[this.activeIndex] || slides[0];
        return slide ? slide.querySelector('[data-featured-player-video]') : getVideos(root)[0] || null;
      },
      isActive: function (host) {
        return host === this.getActiveHost();
      },
      shouldPlay: function (host) {
        return this.inView && !this.userPaused && this.isActive(host);
      },
      shouldAutoplay: function (host) {
        return this.shouldPlay(host) && !prefersReducedMotion();
      },
      getSlotByIframe: function (iframe) {
        for (var i = 0; i < this.slots.length; i += 1) {
          if (this.slots[i].getIframe() === iframe) return this.slots[i];
        }
        return null;
      },
      syncMuteUi: function () {
        var self = this;
        this.slots.forEach(function (slot) {
          slot.applyMute();
          syncVideoUi(slot.host, slot.host.classList.contains('is-playing'), self.muted);
        });
      },
      syncPlayback: function () {
        var self = this;
        this.slots.forEach(function (slot) {
          if (self.shouldAutoplay(slot.host) || (self.shouldPlay(slot.host) && slot.getIframe())) {
            slot.createAndPlay();
          } else {
            slot.pause();
            syncVideoUi(slot.host, false, self.muted);
          }
        });
      },
    };

    controller.slots = getVideos(root).map(function (host) {
      return createSlot(host, controller);
    });

    return controller;
  }

  function bindYtMessages(controller) {
    window.addEventListener('message', function (event) {
      if (!event.origin || event.origin.indexOf('youtube.com') === -1) return;
      var payload = parseYtMessage(event.data);
      if (!payload) return;

      var iframe = null;
      controller.slots.forEach(function (slot) {
        if (slot.getIframe() && slot.getIframe().contentWindow === event.source) {
          iframe = slot.getIframe();
        }
      });
      if (!iframe) return;
      var slot = controller.getSlotByIframe(iframe);
      if (!slot) return;

      var info = payload.info;
      var eventName = payload.event;
      if (eventName === 'onReady' || payload.id === 'onReady') {
        if (controller.shouldPlay(slot.host)) slot.play();
        return;
      }
      if (eventName !== 'onStateChange' && typeof info !== 'number') return;
      var state = typeof info === 'number' ? info : payload.info;
      if (state === STATE_PLAYING) {
        slot.hasPlayed = true;
        slot.applyMute();
        syncVideoUi(slot.host, true, controller.muted);
      } else if (state === STATE_PAUSED) {
        if (slot.hasPlayed && controller.inView && controller.isActive(slot.host)) {
          controller.userPaused = true;
        }
        syncVideoUi(slot.host, false, controller.muted);
      } else if (state === STATE_ENDED && controller.shouldPlay(slot.host)) {
        command(iframe, 'seekTo', [0, true]);
        command(iframe, 'playVideo');
      }
    });
  }

  function bindControls(controller) {
    controller.slots.forEach(function (slot) {
      var host = slot.host;
      syncVideoUi(host, false, controller.muted);

      var playback = host.querySelector('[data-featured-player-playback]');
      var sound = host.querySelector('[data-featured-player-sound]');

      if (playback) {
        playback.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (host.classList.contains('is-playing') && !host.classList.contains('is-paused')) {
            controller.userPaused = true;
            slot.pause();
            syncVideoUi(host, false, controller.muted);
          } else {
            controller.userPaused = false;
            slot.createAndPlay();
          }
        });
      }

      if (sound) {
        sound.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          controller.muted = !controller.muted;
          controller.syncMuteUi();
        });
      }
    });
  }

  function setupIntersection(controller) {
    var target = controller.root.querySelector('.product-featured-player__media') || controller.root;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          controller.inView = Boolean(entries[0] && entries[0].isIntersecting);
          controller.syncPlayback();
        },
        { threshold: 0, rootMargin: '50% 0px' }
      );
      observer.observe(target);
    } else {
      controller.inView = true;
      controller.syncPlayback();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        controller.slots.forEach(function (slot) {
          slot.pause();
        });
        return;
      }
      controller.syncPlayback();
    });
  }

  function initSwiper(controller) {
    if (typeof Swiper === 'undefined') return;

    var root = controller.root;
    var stage = controller.stage;
    var pills = Array.prototype.slice.call(root.querySelectorAll('.product-featured-player__pill'));
    if (!stage || pills.length < 2) return;

    var header = root.querySelector('[data-featured-player-header]');
    var headingEl = root.querySelector('[data-featured-player-heading]');
    var subheadingEl = root.querySelector('[data-featured-player-subheading]');

    function syncCopy(index) {
      var slides = getSlides(stage);
      var slide = slides[index];
      if (!slide) return;
      var heading = slide.getAttribute('data-heading') || '';
      var subheading = slide.getAttribute('data-subheading') || '';
      if (headingEl) {
        headingEl.textContent = heading;
        headingEl.hidden = heading === '';
      }
      if (subheadingEl) {
        subheadingEl.textContent = subheading;
        subheadingEl.hidden = subheading === '';
      }
      if (header) {
        header.hidden = heading === '' && subheading === '';
      }
    }

    function syncPills(index) {
      pills.forEach(function (pill, i) {
        var selected = i === index;
        pill.setAttribute('aria-selected', selected ? 'true' : 'false');
        pill.tabIndex = selected ? 0 : -1;
      });
    }

    function syncSlideInert(index) {
      getSlides(stage).forEach(function (slide, i) {
        var active = i === index;
        slide.inert = !active;
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function sync(index) {
      syncPills(index);
      syncCopy(index);
      syncSlideInert(index);
    }

    var swiper = new Swiper(stage, {
      slidesPerView: 1,
      speed: prefersReducedMotion() ? 0 : 400,
      rewind: true,
      observer: false,
      observeSlideChildren: false,
      resizeObserver: true,
      watchOverflow: true,
      noSwipingSelector: 'iframe, [data-featured-player-playback], [data-featured-player-sound]',
      navigation: {
        nextEl: root.querySelector('[data-featured-player-next]'),
        prevEl: root.querySelector('[data-featured-player-prev]'),
      },
      on: {
        init: function (instance) {
          controller.activeIndex = instance.realIndex;
          sync(instance.realIndex);
        },
        slideChange: function (instance) {
          controller.userPaused = false;
          controller.activeIndex = instance.realIndex;
          sync(instance.realIndex);
          controller.syncPlayback();
        },
      },
    });

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () {
        swiper.slideTo(i);
      });

      pill.addEventListener('keydown', function (event) {
        var nextIndex = i;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (i + 1) % pills.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (i - 1 + pills.length) % pills.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = pills.length - 1;
        } else {
          return;
        }
        event.preventDefault();
        swiper.slideTo(nextIndex);
        pills[nextIndex].focus();
      });
    });
  }

  function init(root) {
    var controller = createController(root);
    bindYtMessages(controller);
    bindControls(controller);
    initSwiper(controller);
    setupIntersection(controller);
    controller.syncPlayback();
  }

  function start() {
    document.querySelectorAll('[data-product-featured-player]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
